<template>
  <div class="row">
    <div class="col-md-12">
      <wordcloud
        v-if="cloudData.length > 0"
        :data="cloudData"
        nameKey="name"
        valueKey="value"
        :rotate="cloudRotate"
        :showTooltip="false"
      />
    </div>
  </div>
</template>

<script>
import wordcloud from "vue-wordcloud";

export default {
  name: "TotalKeywords",
  components: {
    wordcloud
  },
  data() {
    return {
      cloudData: [],
      cloudRotate: {
        from: 0,
        to: 0,
        numOfOrientation: 0
      }
    };
  },
  created() {
    this.loadItems();
  },
  methods: {
    loadItems() {
      this.$store
        .dispatch("dashboard/totalKeywords")
        .then(res => {
          const { data } = res;
          data.forEach(item => {
            this.cloudData.push({
              name: item.keywords_name,
              value: item.total_result
            });
          });
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/dashboard/components/totalKeywords.vue